import { danger } from 'redux-store/reducers/common-reducer';

import { createReducer } from 'utils/redux';
import { API, get, put } from 'utils/api';
import { __t, applyTranslations } from 'utils/language';
import { mapInternalListInfoEntry, mapListInfoAPIResponseEntry } from 'modules/proposal/utils/creator-proposal-utils';

import type { Action, ProposalListInfo, ProposalPageInfoState, ThunkAction } from 'types';
import type { ProposalListInfoAPIResponse } from 'modules/proposal/types/Proposal.type';

applyTranslations(require('./proposal-reducer-errors.i18n.json'));

const SET_INFO = 'creatorProposalInfo/SET_INFO';
const SET_INFO_LOADING_STATUS = 'creatorProposalInfo/SET_INFO_LOADING_STATUS';
const RESET_INFO = 'creatorProposalInfo/RESET_INFO';

const initialState: ProposalPageInfoState = {
  loadingStatus: false,
  info: undefined
};

function setLoadingStatus(listLoadingStatus: boolean) {
  return {
    type: SET_INFO_LOADING_STATUS,
    payload: {
      listLoadingStatus
    }
  };
}

export function resetInfo(): Action {
  return {
    type: RESET_INFO
  };
}

function infoSet(info: ProposalListInfo | undefined) {
  return {
    type: SET_INFO,
    payload: {
      info
    }
  };
}

export function updateListInfo(organizationId: number, listId: number, data: ProposalListInfo): ThunkAction {
  return async (dispatch, getState) => {
    const { proposalCreatePageInfo } = getState();
    const previousState = proposalCreatePageInfo.info;

    dispatch(setLoadingStatus(true));
    try {
      dispatch(infoSet(data));
      const url = API.END_POINTS.CREATOR_PROPOSAL.creatorListInfo(organizationId, listId);
      await put(url, {
        data: mapInternalListInfoEntry(data)
      }, {
        suppressGlobalNotification: true
      });
    } catch (error) {
      dispatch(infoSet(previousState));
      dispatch(danger(__t('proposal_reducer_errors.list_info_update_failed')));
      throw error;
    } finally {
      dispatch(setLoadingStatus(false));
    }
  };
}

export function loadCreatorListInfo(organizationId: number, listId: number): ThunkAction {
  return async (dispatch) => {
    dispatch(setLoadingStatus(true));
    try {
      const url = API.END_POINTS.CREATOR_PROPOSAL.creatorListInfo(organizationId, listId);
      const response = await get(url, {}, { suppressGlobalNotification: true }) as { data: ProposalListInfoAPIResponse };
      const info = response.data;
      const mappedEntry = mapListInfoAPIResponseEntry(info);

      dispatch(infoSet(mappedEntry));

      return mappedEntry;
    } catch (error) {
      dispatch(danger(__t('proposal_reducer_errors.list_info_fetch_failed')));
      throw error;
    } finally {
      dispatch(setLoadingStatus(false));
    }
  };
}

export default createReducer<ProposalPageInfoState, any>('proposalCreatePageInfo', initialState, {
  [RESET_INFO]: () => initialState,
  [SET_INFO_LOADING_STATUS]: (state, { listLoadingStatus }) => ({
    ...state,
    listLoadingStatus
  }),
  [SET_INFO]: (state, { info }) => ({
    ...state,
    info
  })
});
